export const isHomePathname = (pathname: string) =>
  pathname === '/' || pathname === '/reset-password';
